module.exports = __webpack_public_path__ + "static/media/create_sections_find_data_faster.c1402410.mov";